module.exports = __webpack_public_path__ + "img/default-avatar.4f3ddb27.svg";